module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    staticClass: "eco2"
  }, _vm._l((_vm.eco2Visualizations), function(eco2Visualization, index) {
    return _c('g', {
      key: index,
      attrs: {
        "transform": ("translate(" + (eco2Visualization.positionX) + " -" + (eco2Visualization.positionY) + ")")
      }
    }, [_c('use', {
      attrs: {
        "x": "-2",
        "y": "-2",
        "width": "4",
        "height": "4",
        "xlink:href": ("#eco2-volume" + (_vm.level(eco2Visualization.eco2)))
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e67edd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/layer/eco2.vue
// module id = 894
// module chunks = 0